// Generated by ReScript, PLEASE EDIT WITH CARE

import * as JsxRuntime from "react/jsx-runtime";
import * as PaymentElementShimmer$OrcaPaymentPage from "./PaymentElementShimmer.bs.js";

function WalletShimmer(props) {
  return JsxRuntime.jsx(PaymentElementShimmer$OrcaPaymentPage.Shimmer.make, {
    children: JsxRuntime.jsx("div", {
      children: JsxRuntime.jsx("div", {
        className: "w-24 h-3 rounded bg-white bg-opacity-70 self-center "
      }),
      className: "animate-pulse w-full h-12 rounded bg-slate-200 flex justify-center items-center "
    }),
    classname: "opacity-70"
  });
}

let make = WalletShimmer;

export {
  make,
}
/* react/jsx-runtime Not a pure module */
